import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_ZONE_AHU',
  CREATE: 'CREATE_ZONE_AHU',
  EDIT: 'EDIT_ZONE_AHU',
  DELETE: 'DELETE_ZONE_AHU',
};

export const searchAirHandlingUnitInZone = (pageSize, page, sorted, filtered, isPublic, zoneId) => {
  const zoneParams = zoneId === null ? { zone_id__is_null: true } : { zone_id: zoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_ZONE_AHU,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const listAirHandlingUnitInZone = (pageSize, page, sorted, filtered, isPublic, zoneId) => {
  return {
    type: ACTION.LIST,
    payload: searchAirHandlingUnitInZone(pageSize, page, sorted, filtered, isPublic, zoneId)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addAirHandlingUnitToZone = (ahuId, zoneId, quantity) => {
  const formData = new FormData();
  formData.set('rel_ac_central_ac_fan_coil_id', ahuId);
  formData.set('zone_id', zoneId);
  formData.set('quantity', quantity);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_ZONE_AHU,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editAirHandlingUnitInZone = (id, quantity) => {
  const formData = new FormData();
  formData.set('quantity', quantity);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_ZONE_AHU}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeAirHandlingUnitFromZone = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_ZONE_AHU}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/zone/zone_ahu_actions.js